// src/utils/analytics.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-WKHPEVB7XJ";

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("config", GA_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location.pathname, location.search]);

  return null;
}
